import React, { useState } from "react";
import AppNavbar from "../AppNavbar";
import { Link, useLocation } from "react-router-dom";
import {
  FaHome,
  FaFlask,
  FaVirus,
  FaBlog,
  FaCalculator,
  FaBook,
  FaLink,
  FaFileAlt,
  FaBars,
  FaTimes
} from "react-icons/fa";
import "./user.css";

const UserLayout = ({ children }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="user-wrapper">

      <AppNavbar />

      {/* MOBILE OVERLAY */}
      {open && <div className="user-overlay" onClick={() => setOpen(false)} />}

      <div className="user-container">

        {/* SIDEBAR */}
        <aside className={`user-sidebar ${open ? "open" : ""}`}>
          <div className="user-sidebar-header">
            <h4>Majistral Panel</h4>

            <button className="sidebar-close-btn mobile-only" onClick={() => setOpen(false)}>
              <FaTimes />
            </button>
          </div>

          <nav className="user-menu">

            {/* ⭐ Veri Tabanı */}
            <Link
              to="/panel"
              className={location.pathname === "/panel" ? "active" : ""}
            >
              <FaHome /> Veri Tabanı
            </Link>

            {/* ⭐ Formüller */}
            <Link
              to="/panel/formulas"
              className={location.pathname.startsWith("/panel/formulas") ? "active" : ""}
            >
              <FaFlask /> Majistral Formüller
            </Link>

            {/* ⭐ Hastalıklar */}
            <Link
              to="/panel/diseases"
              className={location.pathname.startsWith("/panel/diseases") ? "active" : ""}
            >
              <FaVirus /> Hastalıklar
            </Link>

            {/* ⭐ Blog */}
            <Link
              to="/blogs"
              className={location.pathname.startsWith("/blogs") ? "active" : ""}
            >
              <FaBlog /> Blog
            </Link>

            {/* ⭐ Alkol Hesaplama */}
            <Link
              to="/panel/alcohol"
              className={location.pathname === "/panel/alcohol" ? "active" : ""}
            >
              <FaCalculator /> Alkol Hesaplama
            </Link>

            {/* ⭐ Majistral SUT */}
            <Link
              to="/panel/sut"
              className={location.pathname === "/panel/sut" ? "active" : ""}
            >
              <FaFileAlt /> Majistral SUT
            </Link>

            {/* ⭐ Kısaltmalar */}
            <Link
              to="/panel/kisaltmalar"
              className={location.pathname === "/panel/kisaltmalar" ? "active" : ""}
            >
              <FaBook /> Kısaltmalar Sözlüğü
            </Link>

            {/* ⭐ Dokümanlar */}
            <Link
              to="/panel/dokumanlar"
              className={location.pathname === "/panel/dokumanlar" ? "active" : ""}
            >
              <FaFileAlt /> Dokümanlar
            </Link>

            {/* ⭐ TEB Majistral */}
            <Link
              to="/panel/teb"
              className={location.pathname === "/panel/teb" ? "active" : ""}
            >
              <FaLink /> TEB Majistral Hesaplama
            </Link>

          </nav>

        </aside>

        {/* MOBILE HAMBURGER */}
        <button className="user-hamburger mobile-only" onClick={() => setOpen(true)}>
          <FaBars size={22} />
        </button>

        {/* CONTENT */}
        <main className="user-content">{children}</main>
      </div>
    </div>
  );
};

export default UserLayout;